import BasicSpriteEffect from "./BasicSpriteEffect";
import EffectCache from "./EffectCache";

export default class BasicSpriteEffectCache extends EffectCache {
    constructor() {
        super();
        /**
         * @constant
         * @type {number}
         */
        this.initialCacheSize = 100;
        /**
         * @constant
         * @type {number}
         */
        this.growAmount = 50;
    }

    /**
     * @override
     * @returns {number}
     */
    getGrowAmount() {
        return this.growAmount;
    }

    /**
     * @override
     * @returns {number}
     */
    getInitialSize() {
        return this.initialCacheSize;
    }

    /**
     * @override
     * @returns {BasicSpriteEffect}
     */
    createInstance() {
        return new BasicSpriteEffect();
    }
}